/**
 * mappingUtils.js — helpers for app_database_mapping rows on the frontend.
 *
 * WHAT: dedupeMappingsByIdentifier collapses the per-app-link rows the
 * mappings API returns (M:N — one row per linked application) down to one row
 * per database_identifier, preferring the primary-app link so its display
 * name is the one shown.
 *
 * WHY: Dropdowns that list DATABASES (e.g. the connection forms' Database
 * Identifier select) must show each database once, but the mappings list
 * endpoint correctly returns one row per app link — a database serving N
 * applications appeared N times. Single shared helper so all five technology
 * connection components dedupe identically.
 */
export function dedupeMappingsByIdentifier(mappings) {
  const seen = new Map();
  for (const m of mappings) {
    const key = (m.database_identifier || '').toUpperCase();
    const existing = seen.get(key);
    if (!existing || (m.is_primary_app && !existing.is_primary_app)) {
      seen.set(key, m);
    }
  }
  return [...seen.values()];
}
